import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { MediaBrandForms, MediaFormBrandType } from '../mediaTypes'

export const FONT_FORM_SCHEMA = genSchema(SCHEMA.video.font, {
  player: FONT_FIELDS.base,
  tooltip: FONT_FIELDS.base,
})

const TypographyPlayer: MediaFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.player}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.audio.tags.player')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TypographyTooltip: MediaFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.tooltip}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.audio.tags.tooltip')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const MediaTypography: MediaFormBrandType = ({ device, edited, element, setForm }) => {
  const values = useElementFontValues('video', device, element?.font)
  const styles = useElementFontCss('video', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.player}
        font='player'
        onClick={setForm}
        styles={styles.player}
        values={values.player}
      >
        {t('elements.audio.tags.player')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.tooltip}
        font='tooltip'
        onClick={setForm}
        styles={styles.tooltip}
        values={values.tooltip}
      >
        {t('elements.audio.tags.tooltip')}
      </BrandButtonFont>
    </Padding>
  )
}

const FORM_MAP: MediaBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: MediaTypography,
  player: TypographyPlayer,
  tooltip: TypographyTooltip,
}

export default FORM_MAP
